const NotFoundPage = () => {
  return(
    <div className="centered">
      <p>Page not found!</p>
    </div>
  );
};

export default NotFoundPage;